import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.admin.pacs.info.data = { ...data };
  });
};

const get = async (store, id, params = {}) => {
  store.setState((state) => {
    state.admin.pacs.info.busy = true;
  });

  try {
    const response = await Http.get(`api/pacs/${id}`, { params });

    store.setState((state) => {
      state.admin.pacs.info.data = response.data;
      state.admin.pacs.info.busy = false;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.admin.pacs.info.error = error.data || error;
      state.admin.pacs.info.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.admin.pacs.info.error = undefined;
};

const reset = (store) => (state) => {
  state.admin.pacs.info = { ...initialState };
};

const actions = {
  setData,
  get,
  reset,
  resetError,
};

const PacsInfoStore = {
  state: () => initialState,
  actions,
};

export default PacsInfoStore;
